<template>
  <div class="rotation-config">
    <el-container direction="vertical">
      <AdminHeader @logout="handleLogout" />

      <el-container>
        <AdminSidebar />

        <el-main>
          <el-card shadow="always" header="全局默认（可一键应用）">
            <el-form :model="globalForm" label-width="140px" inline>
              <el-form-item label="全屏欢迎语(秒)">
                <el-input-number v-model="globalForm.welcome_fullscreen_seconds" :min="5" :max="300" />
              </el-form-item>
              <el-form-item label="患者页面(秒)">
                <el-input-number v-model="globalForm.patient_page_seconds" :min="5" :max="300" />
              </el-form-item>
              <el-form-item label="视频切换方式">
                <el-radio-group v-model="globalForm.video_switch_mode">
                  <el-radio label="FIXED_WINDOW">按秒切换</el-radio>
                  <el-radio label="PLAY_TO_END">播完再切</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="视频页面(秒)" v-if="globalForm.video_switch_mode === 'FIXED_WINDOW'">
                <el-input-number v-model="globalForm.video_page_seconds" :min="5" :max="600" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="savingGlobal" @click="saveGlobal">保存全局默认</el-button>
              </el-form-item>
            </el-form>
            <div class="hint">半屏欢迎语时长继承“患者页面(秒)”。</div>
          </el-card>

          <el-card shadow="always" header="门店配置列表" style="margin-top: 16px;">
            <div style="margin-bottom: 12px; display: flex; gap: 12px; align-items: center;">
              <el-input v-model="search" placeholder="搜索门店名称/ID" style="width: 260px;" clearable />
              <el-select v-model="sourceFilter" placeholder="来源筛选" clearable style="width: 180px;">
                <el-option label="门店自定义" value="STORE" />
                <el-option label="全局默认" value="GLOBAL" />
                <el-option label="系统默认" value="DEFAULT" />
              </el-select>
              <el-button type="primary" :loading="loading" @click="fetchList">刷新</el-button>
            </div>

            <el-table :data="filteredList" border style="width: 100%" height="520">
              <el-table-column prop="store_id" label="门店ID" width="100" />
              <el-table-column prop="store_name" label="门店名称" min-width="180" />
              <el-table-column prop="welcome_fullscreen_seconds" label="全屏欢迎语(秒)" width="140" />
              <el-table-column prop="patient_page_seconds" label="患者页面(秒)" width="120" />
              <el-table-column prop="video_switch_mode" label="视频切换" width="120">
                <template #default="scope">
                  <span>{{ scope.row.video_switch_mode === 'PLAY_TO_END' ? '播完再切' : '按秒切换' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="video_page_seconds" label="视频秒数" width="100" />
              <el-table-column prop="source" label="生效来源" width="110" />
              <el-table-column label="操作" width="200">
                <template #default="scope">
                  <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
                  <el-button type="text" :disabled="scope.row.source !== 'STORE'" @click="resetToGlobal(scope.row)">恢复全局</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <el-dialog title="编辑门店轮播时长" :visible.sync="editVisible" width="520px">
            <el-form :model="editForm" label-width="140px">
              <el-form-item label="门店ID">
                <el-input v-model="editForm.store_id" disabled />
              </el-form-item>
              <el-form-item label="全屏欢迎语(秒)">
                <el-input-number v-model="editForm.welcome_fullscreen_seconds" :min="5" :max="300" />
              </el-form-item>
              <el-form-item label="患者页面(秒)">
                <el-input-number v-model="editForm.patient_page_seconds" :min="5" :max="300" />
              </el-form-item>
              <el-form-item label="视频切换方式">
                <el-radio-group v-model="editForm.video_switch_mode">
                  <el-radio label="FIXED_WINDOW">按秒切换</el-radio>
                  <el-radio label="PLAY_TO_END">播完再切</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="视频页面(秒)" v-if="editForm.video_switch_mode === 'FIXED_WINDOW'">
                <el-input-number v-model="editForm.video_page_seconds" :min="5" :max="600" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取消</el-button>
              <el-button type="primary" :loading="savingStore" @click="saveStore">保存</el-button>
            </div>
          </el-dialog>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config';
import { clearAuthInfo } from '@/utils/auth';
import { parseApiResponse, handleApiError } from '@/utils/apiResponse';
import AdminHeader from '@/components/AdminHeader.vue';
import AdminSidebar from '@/components/AdminSidebar.vue';

export default {
  name: 'RotationConfigPanel',
  components: {
    AdminHeader,
    AdminSidebar
  },
  data() {
    return {
      loading: false,
      savingGlobal: false,
      savingStore: false,
      list: [],
      search: '',
      sourceFilter: '',
      globalForm: {
        welcome_fullscreen_seconds: 15,
        patient_page_seconds: 15,
        video_page_seconds: 30,
        video_switch_mode: 'FIXED_WINDOW'
      },
      editVisible: false,
      editForm: {
        store_id: '',
        welcome_fullscreen_seconds: 15,
        patient_page_seconds: 15,
        video_page_seconds: 30,
        video_switch_mode: 'FIXED_WINDOW'
      }
    };
  },
  computed: {
    filteredList() {
      const q = (this.search || '').trim().toLowerCase();
      return (this.list || []).filter(r => {
        if (this.sourceFilter && r.source !== this.sourceFilter) return false;
        if (!q) return true;
        const id = String(r.store_id || '').toLowerCase();
        const name = String(r.store_name || '').toLowerCase();
        return id.includes(q) || name.includes(q);
      });
    }
  },
  created() {
    this.fetchGlobal();
    this.fetchList();
  },
  methods: {
    async fetchGlobal() {
      try {
        const resp = await axios.get(config.getApiUrl(config.apiEndpoints.screenRotationConfig.globalGet));
        const parsed = parseApiResponse(resp);
        if (parsed.success && parsed.data) {
          const d = parsed.data;
          this.globalForm = {
            welcome_fullscreen_seconds: d.welcome_fullscreen_seconds ?? 15,
            patient_page_seconds: d.patient_page_seconds ?? 15,
            video_page_seconds: d.video_page_seconds ?? 30,
            video_switch_mode: d.video_switch_mode ?? 'FIXED_WINDOW'
          };
        }
      } catch (e) {
        // 静默：没有全局配置时使用默认即可
      }
    },
    async fetchList() {
      this.loading = true;
      try {
        const resp = await axios.get(config.getApiUrl(config.apiEndpoints.screenRotationConfig.list));
        const parsed = parseApiResponse(resp);
        if (parsed.success && parsed.data) {
          this.list = Array.isArray(parsed.data) ? parsed.data : [];
        } else {
          this.$message.error(parsed.message || '获取列表失败');
        }
      } catch (e) {
        const er = handleApiError(e);
        this.$message.error(er.message || '获取列表异常');
      } finally {
        this.loading = false;
      }
    },
    async saveGlobal() {
      this.savingGlobal = true;
      try {
        const resp = await axios.put(
          config.getApiUrl(config.apiEndpoints.screenRotationConfig.globalUpsert),
          this.globalForm
        );
        const parsed = parseApiResponse(resp);
        if (parsed.success) {
          this.$message.success(parsed.message || '保存成功');
          this.fetchList();
        } else {
          this.$message.error(parsed.message || '保存失败');
        }
      } catch (e) {
        const er = handleApiError(e);
        this.$message.error(er.message || '保存异常');
      } finally {
        this.savingGlobal = false;
      }
    },
    openEdit(row) {
      this.editForm = {
        store_id: row.store_id,
        welcome_fullscreen_seconds: row.welcome_fullscreen_seconds,
        patient_page_seconds: row.patient_page_seconds,
        video_page_seconds: row.video_page_seconds,
        video_switch_mode: row.video_switch_mode || 'FIXED_WINDOW'
      };
      this.editVisible = true;
    },
    async saveStore() {
      this.savingStore = true;
      try {
        const storeId = this.editForm.store_id;
        const payload = {
          welcome_fullscreen_seconds: this.editForm.welcome_fullscreen_seconds,
          patient_page_seconds: this.editForm.patient_page_seconds,
          video_page_seconds: this.editForm.video_page_seconds,
          video_switch_mode: this.editForm.video_switch_mode || 'FIXED_WINDOW'
        };
        const resp = await axios.put(
          config.getApiUrl(config.apiEndpoints.screenRotationConfig.storeUpsert, storeId),
          payload
        );
        const parsed = parseApiResponse(resp);
        if (parsed.success) {
          this.$message.success(parsed.message || '保存成功');
          this.editVisible = false;
          this.fetchList();
        } else {
          this.$message.error(parsed.message || '保存失败');
        }
      } catch (e) {
        const er = handleApiError(e);
        this.$message.error(er.message || '保存异常');
      } finally {
        this.savingStore = false;
      }
    },
    async resetToGlobal(row) {
      try {
        await this.$confirm('确定恢复为全局默认吗？', '提示', { type: 'warning' });
        const resp = await axios.delete(
          config.getApiUrl(config.apiEndpoints.screenRotationConfig.storeDelete, row.store_id)
        );
        const parsed = parseApiResponse(resp);
        if (parsed.success) {
          this.$message.success(parsed.message || '已恢复');
          this.fetchList();
        } else {
          this.$message.error(parsed.message || '操作失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          const er = handleApiError(e);
          this.$message.error(er.message || '操作异常');
        }
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuthInfo();
        this.$message.success('已退出登录');
        this.$router.push('/login');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.rotation-config {
  height: 100vh;
  overflow: hidden;
}
.el-container {
  height: 100%;
}
.header-container {
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
}
.el-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}
.header-right {
  display: flex;
  align-items: center;
}
.el-aside {
  background-color: #f5f7fa;
  flex-shrink: 0;
}
.el-main {
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}
.hint {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}
</style>

